import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { INFRASTRUCTURE_TABS, type InfrastructureTab } from '@/features/admin/shared/tabs';
import { InfrastructureDetailPage } from '@/features/admin/infrastructures/infrastructure-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Détail d'une infrastructure. L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/resources/infrastructures/$infrastructureId')({
  validateSearch: (search: Record<string, unknown>): { tab: InfrastructureTab } => ({
    tab: INFRASTRUCTURE_TABS.parse(search['tab']),
  }),
  component: InfrastructureRoute,
});

function InfrastructureRoute() {
  const { tenant, infrastructureId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="infrastructures"
      crumbs={[
        { label: t('nav.items.infrastructures') },
        { label: <EntityName tenantId={tenant} kind="infrastructure" id={infrastructureId} /> },
      ]}
    >
      <InfrastructureDetailPage
        tenantId={tenant}
        infrastructureId={infrastructureId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
